/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const TitleText = styled.span<{ fadeLinesAfterFirst: boolean }>`
  img {
    max-height: 1em;
    vertical-align: text-bottom;

    &.emoji {
      height: 1em;
    }
  }

  span:not(:first-of-type) {
    ${({ fadeLinesAfterFirst }) =>
      fadeLinesAfterFirst
        ? `color: ${token('color.text.subtlest', colors.N200)}`
        : null};
  }
`;
